export default {
  en: {
    appName: 'SECURE TRAVEL',
    selfBooking: 'SELF BOOKING',
    language: 'Language',
    secBooking: 'Secure Storage Booking',
    passengerInfo: 'Passenger Information',
    thirdParty: 'Third Party Pickup',
    hazardous: 'Prohibited / Dangerous Items Declaration',
    legal: 'Legal Agreement',
    submit: 'Confirm & Secure Storage',
    saveBooking: 'Save Booking',
    submitting: 'Submitting...',
    store: 'Storage Facility',
    storePlaceholder: 'Select a facility...',
    selectStoreFirst: 'Select a storage facility first.',
    noPackages: 'No baggage packages are configured for this store.',
    addItem: '+ Add Item',
    luggage: 'Luggage Items',
    luggageSizePlaceholder: 'Select luggage size...',
    dropoff: 'Drop-off Date & Time',
    pickup: 'Pick-up Date & Time',
    timezone: 'Store timezone',
    pickupAfter: 'Pick-up time cannot be before drop-off time.',
    dropoffBusinessHours: 'Drop-off time must be within store business hours:',
    pickupBusinessHours: 'Pick-up time must be within store business hours:',
    qrTitle: 'Your QR Code',
    bookingConfirmed: 'Booking Confirmed',
    bookingDone: 'Your luggage storage has been secured.',
    bookingStage1Done: 'Your booking is saved. Please complete your passenger details before drop-off.',
    completeDetailsTitle: 'Complete Your Details',
    completeDetails: 'Complete Booking Details',
    completeDetailsHint: 'Add your passenger information, declaration, and signature using the link below. You can also return to this page any time before drop-off.',
    createNewBooking: 'Create New Booking',
    showAtCounter: 'Show this QR code at the counter',
    bookingDetails: 'Booking Details',
    mobile: 'Mobile Number',
    passport: 'Passport Number',
    licence: 'or Driver License Number',
    eitherPassportOrLicence: 'Provide either passport number or driver license number.',
    identityExclusive: 'Provide either passport number or driver license number, not both.',
    termsConfirm: 'I have read and agree to the Terms & Conditions.',
    termsConfirmRequired: 'You must agree to the Terms & Conditions to continue.',
    required: 'is required.'
  },
  zh: {
    appName: '安全旅行',
    selfBooking: '自助预订',
    language: '语言',
    secBooking: '行李寄存预订',
    passengerInfo: '旅客信息',
    thirdParty: '第三方取件',
    hazardous: '违禁/危险品申报',
    legal: '法律协议',
    submit: '确认并完成寄存',
    saveBooking: '保存预订',
    submitting: '提交中...',
    store: '寄存门店',
    storePlaceholder: '请选择门店...',
    selectStoreFirst: '请先选择寄存门店。',
    noPackages: '该门店暂未配置行李套餐。',
    addItem: '+ 添加行李',
    luggage: '行李项目',
    luggageSizePlaceholder: '请选择行李尺寸...',
    dropoff: '寄存日期与时间',
    pickup: '取件日期与时间',
    timezone: '门店时区',
    pickupAfter: '取件时间不能早于寄存时间。',
    dropoffBusinessHours: '寄存时间必须在门店营业时间内：',
    pickupBusinessHours: '取件时间必须在门店营业时间内：',
    qrTitle: '二维码',
    bookingConfirmed: '预订成功',
    bookingDone: '您的行李寄存已确认。',
    bookingStage1Done: '预订已保存。请在寄存前补全旅客信息。',
    completeDetailsTitle: '补全预订信息',
    completeDetails: '补全预订详情',
    completeDetailsHint: '请通过下方链接填写旅客信息、申报和签名。您也可在寄存前随时返回此页面。',
    createNewBooking: '新建预订',
    showAtCounter: '请在柜台出示此二维码',
    bookingDetails: '预订详情',
    mobile: '手机号',
    passport: '护照号',
    licence: '或 驾照号',
    eitherPassportOrLicence: '请填写护照号或驾照号其中一项。',
    identityExclusive: '护照号与驾照号只能填写其中一项。',
    termsConfirm: '我已阅读并同意条款与条件。',
    termsConfirmRequired: '请先勾选同意条款与条件。',
    required: '为必填项。'
  }
}



// WEBPACK FOOTER //
// ./src/i18n.js